import { BoxTile } from '../BoxTile/BoxTile';
import { CashTile } from '../CashTile/CashTile';
import { CoinTile } from '../CoinTile/CoinTile';
import { DiceTile } from '../DiceTile/DiceTile';
import { EnergyTile } from '../EnergyTile/EnergyTile';
import { GoodsTile } from '../GoodsTile/GoodsTile';
import { MaterialTile } from '../MaterialTile/MaterialTile';
import { ResourceTile } from '../ResourceTile/ResourceTile';
import { StarsTile } from '../StarsTile/StarsTile';
import { VipTile } from '../VipTile/VipTile';

interface TilesMapType {
  Resource: typeof ResourceTile;
  Material: typeof MaterialTile;
  Product: typeof GoodsTile;
  tgem: typeof CoinTile;
  str: typeof StarsTile;
  cash: typeof CashTile;
  Box: typeof BoxTile;
  dice: typeof DiceTile;
  VIP: typeof VipTile;
  Energy: typeof EnergyTile;
}

const tilesMap = {
  Resource: ResourceTile,
  Material: MaterialTile,
  Product: GoodsTile,
  tgem: CoinTile,
  str: StarsTile,
  cash: CashTile,
  Box: BoxTile,
  dice: DiceTile,
  VIP: VipTile,
  Energy: EnergyTile,
} as const;

export { tilesMap, type TilesMapType };
